export const CAPTURE_FIRST_AI_TIMEOUT_MS = 180000;

export const CAPTURE_FIRST_AI_TIMEOUT_MESSAGE = (
  'The AI extraction took too long. Try a shorter note, or save the raw note first and let details be found after saving.'
);

export const getCaptureFirstAiErrorMessage = (error = {}) => {
  const code = String(error?.code || '').trim();
  const message = String(error?.message || error || '').trim();

  if (
    code === 'functions/deadline-exceeded'
    || code === 'deadline-exceeded'
    || message.toLowerCase().includes('deadline-exceeded')
  ) {
    return CAPTURE_FIRST_AI_TIMEOUT_MESSAGE;
  }

  return message || 'Capture-first AI extraction failed. The local sandbox output is unchanged.';
};
